import colors from "./brand.colors";

// Point unique de configuration de la marque : nom, slogan, couleurs, logo.
export const BRAND = {
  name: "SanitDocs",
  shortName: "SanitDocs",
  tagline: "Le suivi documentaire du transport sanitaire.",
  description: "Suivi et récupération des prescriptions médicales de transport (PMT) et documents manquants.",
  copyright: `© ${new Date().getFullYear()} SanitDocs`,
  colors,
  logo: {
    // Couleurs du pictogramme (croix de vie à six branches + document)
    star: colors.brand[700],
    starLight: colors.accent[500],
    document: "#FFFFFF",
    documentLines: colors.brand[700],
  },
};

export default BRAND;
